import { DOCUMENT } from '@angular/common';
import * as i0 from '@angular/core';
import { InjectionToken, inject, Injectable, Inject, NgModule, Optional, SkipSelf } from '@angular/core';

const WINDOW = new InjectionToken('An abstraction over global window object', {
    factory: () => {
        const { defaultView } = inject(DOCUMENT);
        if (!defaultView) {
            throw new Error('Window is not available');
        }
        return defaultView;
    },
});
const STORAGE_STRATEGY = new InjectionToken('Storage Strategy');
var STORAGE_STRATEGY_TYPE;
(function (STORAGE_STRATEGY_TYPE) {
    STORAGE_STRATEGY_TYPE["LOCAL"] = "localStorage";
    STORAGE_STRATEGY_TYPE["SESSION"] = "sessionStorage";
})(STORAGE_STRATEGY_TYPE || (STORAGE_STRATEGY_TYPE = {}));
/* This class is a service that provides a way to store data in the browser's local storage. */
class StorageService {
    constructor(strategy, window) {
        this.strategy = strategy;
        this.window = window;
    }
    /**
     * "This function sets the strategy to be used by the storage service."
     * @param {STORAGE_STRATEGY_TYPE} strategy - STORAGE_STRATEGY_TYPE
     */
    setStrategy(strategy) {
        this.strategy = strategy;
    }
    /**
     * It gets the value of the token from the local storage
     * @param {string} value - string - The key of the item to get from the storage.
     * @returns The token is being returned.
     */
    get(value) {
        const token = this.window[this.strategy].getItem(value);
        return token ? JSON.parse(token) : null;
    }
    /**
     * It takes a key and a value, and then it sets the value in the browser's local storage
     * @param {string} key - string - The key to store the value under.
     * @param {any} value - any - The value to store.
     */
    set(key, value) {
        this.window[this.strategy].setItem(key, JSON.stringify(value));
    }
    /**
     * It removes the item from the storage
     * @param {string} key - string - The key of the item to remove from the storage.
     */
    clear(key) {
        this.window[this.strategy].removeItem(key);
    }
}
StorageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: StorageService, deps: [{ token: STORAGE_STRATEGY }, { token: WINDOW }], target: i0.ɵɵFactoryTarget.Injectable });
StorageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: StorageService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: StorageService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: STORAGE_STRATEGY_TYPE, decorators: [{
                    type: Inject,
                    args: [STORAGE_STRATEGY]
                }] }, { type: Window, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }]; } });

class StorageModule {
    constructor(parentModule) { }
    static forRoot(config = STORAGE_STRATEGY_TYPE.LOCAL) {
        return {
            ngModule: StorageModule,
            providers: [StorageService, { provide: STORAGE_STRATEGY, useValue: config }],
        };
    }
    static forChild(config) {
        return {
            ngModule: StorageModule,
            providers: [StorageService],
        };
    }
}
StorageModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: StorageModule, deps: [{ token: StorageModule, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.NgModule });
StorageModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: StorageModule });
StorageModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: StorageModule, providers: [StorageService] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: StorageModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [],
                    providers: [StorageService],
                    exports: [],
                }]
        }], ctorParameters: function () { return [{ type: StorageModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }]; } });

/*
 * Public API Surface of storage
 */

/**
 * Generated bundle index. Do not edit.
 */

export { STORAGE_STRATEGY, STORAGE_STRATEGY_TYPE, StorageModule, StorageService, WINDOW };
//# sourceMappingURL=tbtk-storage.mjs.map
